function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStAndrews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "90pt",
    height: "90pt",
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 84.421875 27 L 54.808594 44.910156 L 84.421875 63 L 84.421875 68.578125 L 74.699219 68.578125 L 45.179688 50.761719 L 15.300781 68.578125 L 5.578125 68.578125 L 5.578125 63 L 35.191406 44.910156 L 5.578125 27 L 5.578125 21.421875 L 15.300781 21.421875 L 45.179688 39.238281 L 74.699219 21.421875 L 84.421875 21.421875 Z M 3.960938 19.351562 L 86.039062 19.351562 L 86.039062 70.648438 L 3.960938 70.648438 Z M 3.960938 19.351562 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStAndrews);
export default __webpack_public_path__ + "static/media/st-andrews.ca013d5d25e8fd36fe2bd7cabb946fdf.svg";
export { ForwardRef as ReactComponent };